import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx } from '@emotion/core';
import { Component, createRef } from 'react';
import { CardArt } from '../CardIcons';
import { getCardType, getCardTypeInfo, maskCard } from '../cardUtils';
import { PROPS_TO_FILTER } from './constants';
import { validateCardNumber } from './validations';
import { FloatingLabelInput } from '../../FloatingLabelInput';
import { CustomInputContainer } from '../../CustomInputContainer';
import { withCursorTracking } from '../../../HigherOrderComponents';
import { filterProps, isFunction, stripNonDigits } from '../../../../utils';
import { getInputContainerPadding, inputContainerStyles, inputStyles, wrapperStyles } from '../commonStyles';
import { rtlNumberOnlyStyles } from '../../commonStyles';
import { inputStyleOverrides as cardNumberInputStyles } from './styles';

class CardNumberBase extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      isFocused: false
    });

    _defineProperty(this, "cardNumberRef", this.props.forwardedRef || createRef(this, 'cardNumberRef'));

    _defineProperty(this, "getCardType", cardNumber => {
      var {
        allowedCardTypes,
        cardType,
        shouldAutoDetectCardType
      } = this.props;
      return shouldAutoDetectCardType ? getCardType(cardNumber, allowedCardTypes) : getCardTypeInfo(cardType);
    });

    _defineProperty(this, "changeHandler", e => {
      e.persist();
      var {
        target: {
          value
        }
      } = e;
      var {
        changeHandler,
        value: oldValue,
        shouldAutoDetectCardType
      } = this.props;
      var newValue = stripNonDigits(value);
      var cardType = this.getCardType(newValue);

      if (isFunction(changeHandler)) {
        var _cardType$gaps;

        var unmaskedLength = e.target.maxLength - ((cardType === null || cardType === void 0 ? void 0 : (_cardType$gaps = cardType.gaps) === null || _cardType$gaps === void 0 ? void 0 : _cardType$gaps.length) || 0);
        var isMaxLength = newValue.length === unmaskedLength;
        var validation = validateCardNumber(newValue, cardType, this.props.allowedCardTypes, this.props.luhnValidateJaws);
        changeHandler(e, newValue, oldValue, _objectSpread({
          isMaxLength,
          validation
        }, shouldAutoDetectCardType && {
          cardType: cardType.type
        }));
      }
    });

    _defineProperty(this, "focusAndBlurHandler", e => {
      e.persist();
      var {
        type
      } = e;
      var handler = this.props["".concat(type, "Handler")];

      if (isFunction(handler)) {
        handler(e);
      }

      this.setState(() => ({
        isFocused: type === 'focus'
      }));
    });
  }

  componentDidUpdate(prevProps) {
    var _prevProps$allowedCar, _this$props$allowedCa;

    var {
      onAfterAllowedCardTypesChange,
      onAfterCardTypeChange,
      shouldAutoDetectCardType,
      cardType,
      value
    } = this.props;
    var prevAllowedCardTypesLength = (_prevProps$allowedCar = prevProps.allowedCardTypes) === null || _prevProps$allowedCar === void 0 ? void 0 : _prevProps$allowedCar.length;
    var currentAllowedCardTypesLength = (_this$props$allowedCa = this.props.allowedCardTypes) === null || _this$props$allowedCa === void 0 ? void 0 : _this$props$allowedCa.length;
    var isAllowedCardTypesChange = prevAllowedCardTypesLength !== currentAllowedCardTypesLength;
    var isCardTypeChange = !shouldAutoDetectCardType && prevProps.cardType !== cardType;

    if (isCardTypeChange && isFunction(onAfterCardTypeChange) || isAllowedCardTypesChange && isFunction(onAfterAllowedCardTypesChange)) {
      var hook = isCardTypeChange ? onAfterCardTypeChange : onAfterAllowedCardTypesChange;

      var _cardType = this.getCardType(value);

      var validation = validateCardNumber(value, _cardType, this.props.allowedCardTypes, this.props.luhnValidateJaws);
      hook({
        cardType: _cardType.type,
        validation
      });
    }
  }

  render() {
    var {
      cardArtStyleOverrides,
      cardType,
      containerStyleOverrides,
      displayCardArt,
      displayError,
      error,
      hasError,
      id,
      inputContainerStyleOverrides: customInputStyleOverrides,
      inputStyleOverrides,
      truncateCardTo,
      truncatedPrefix,
      value,
      isV2
    } = this.props;
    var {
      isFocused
    } = this.state;
    var filteredProps = filterProps(this.props, PROPS_TO_FILTER);
    var cardTypeInfo = cardType ? getCardTypeInfo(cardType) : this.getCardType(value);
    var {
      lengths,
      gaps,
      type
    } = cardTypeInfo;
    var maxLength = Math.max(...lengths) + gaps.length;
    var minLength = Math.min(...lengths) + gaps.length;
    var maskedValue = maskCard(value, cardTypeInfo);
    var noError = !displayError && !hasError;
    var label = this.props.label;

    if (truncateCardTo && value.length && !isFocused && noError) {
      maxLength = minLength = truncateCardTo;
      maskedValue = "".concat(truncatedPrefix).concat(value.substring(value.length - truncateCardTo));
      label = this.props.truncatedLabel || label;
    }

    return jsx(CustomInputContainer, {
      blurHandler: this.focusAndBlurHandler,
      containerStyleOverrides: containerStyleOverrides,
      displayError: {
        message: displayError,
        styling: displayError || hasError
      },
      error: error,
      focusHandler: this.focusAndBlurHandler,
      inputContainerStyleOverrides: [getInputContainerPadding(displayCardArt), customInputStyleOverrides],
      inputId: id
    }, focusAndBlurHandler => jsx("div", {
      css: wrapperStyles
    }, displayCardArt && jsx(CardArt, {
      cardType: type,
      isLeft: displayCardArt === 'left',
      isV2: isV2,
      styleOverrides: cardArtStyleOverrides
    }), jsx(FloatingLabelInput, _extends({}, filteredProps, {
      autoComplete: "cc-number",
      blurHandler: focusAndBlurHandler,
      changeHandler: this.changeHandler,
      containerStyleOverrides: inputContainerStyles,
      focusHandler: focusAndBlurHandler,
      forwardedRef: this.cardNumberRef,
      hasError: !noError,
      inputMode: "numeric",
      inputStyleOverrides: [inputStyles, rtlNumberOnlyStyles, inputStyleOverrides, cardNumberInputStyles],
      label: label,
      maxLength: maxLength,
      minLength: minLength,
      name: "cardnumber",
      required: true,
      type: "tel",
      value: maskedValue
    }))));
  }

}

_defineProperty(CardNumberBase, "defaultProps", {
  allowedCardTypes: [],
  id: 'cardNumber',
  isV2: false,
  shouldAutoDetectCardType: true,
  truncatedPrefix: ''
});

var CardNumber = withCursorTracking(CardNumberBase, stripNonDigits);
export { CardNumber };